export const candidateDetailsStoreKey = 'candidateDetails';
